/**
 * Tauri runtime detection + multi-window helpers.
 *
 * The web build runs in browsers too; everything here is no-op when
 * Tauri's IPC bridge is absent.
 */

export function isTauri(): boolean {
  return typeof window !== 'undefined' && (window as any).__TAURI_INTERNALS__ !== undefined;
}

/** Open a new native window pointing at the given route. No-op in browser. */
export async function openWindow(opts: {
  label: string;
  title: string;
  url: string;
}): Promise<boolean> {
  if (!isTauri()) {
    // Browser fallback — pop-out tab.
    window.open(opts.url, opts.label, 'noopener,noreferrer,popup');
    return true;
  }
  try {
    const { invoke } = await import('@tauri-apps/api/core');
    await invoke('new_window', { label: opts.label, title: opts.title, url: opts.url });
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('openWindow failed', e);
    return false;
  }
}

/** Reads the route's `?solo=...` query param. Used in pop-out windows to render
 *  only one panel (telemetry-only / map-only) instead of the full shell. */
export function getSoloMode(): string | null {
  if (typeof window === 'undefined') return null;
  const p = new URLSearchParams(window.location.search);
  return p.get('solo');
}
